import React from 'react';
import Button from '@material-ui/core/Button';
import { Container } from '@material-ui/core';
import clsx from 'clsx';
import { connect, useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { addAlert } from 'store/actions/alert/alerts';
import {
  authDelRequestWithParam,
  authGetRequestWithParam,
  authPostRequest,
} from 'helpers/apiRequests';

import { formStyles } from 'consts/styles/Form';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Icons from 'consts/icons';
import { parseDate } from 'utils/main';
import CustomizedTable from 'components/common/components/tablev2/CustomizedTable';

const AddApprovedDronesForm = props => {
  const { language, setActiveStep, zoneUid, timezone, addRender } = props;

  const formClasses = formStyles();
  const classesButtons = ButtonsUseStyles();

  const dispatch = useDispatch();
  const [zoneDrones, setZoneDrones] = React.useState([]);
  const [newDroneId, setNewDroneId] = React.useState('');
  const [newDroneError, setNewDroneError] = React.useState(false);
  const [droneThatIsPresentInDb, setDroneThatIsPresentInDb] = React.useState(
    null
  );

  React.useEffect(() => {
    if (zoneUid) handleGetAllZoneIdentificationsRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = event => {
    setNewDroneError(false);
    setNewDroneId(event.target.value);
  };

  const addDrone = () => {
    if (!newDroneId.trim().length) return setNewDroneError(true);
    if (!checkIfDroneIsInTable(newDroneId))
      handleApiRequestAddDrone(newDroneId);
    setNewDroneId('');
  };

  const handleGetAllZoneIdentificationsRequest = () => {
    authGetRequestWithParam('areas', zoneUid).then(result => {
      if (result.status === 200) {
        if (result.data.identifications) {
          setZoneDrones(result.data.identifications);
        }
      }
    });
  };

  const checkIfDroneIsInTable = id => {
    const isElementPresentInCurrentDronesList = zoneDrones.find(
      zoneObject => zoneObject.drones.id === id
    );
    if (isElementPresentInCurrentDronesList) {
      dispatch(
        addAlert({
          title: language.zonesDetails.addForm.addApprovedDronesForm.danger_,
          desc: language.zonesDetails.addForm.addApprovedDronesForm.dangerInfo_,
          type: 'warning',
        })
      );
      setNewDroneError(true);

      return true;
    }

    return false;
  };

  const handleDeletion = identificationUid => {
    setZoneDrones(currDrones =>
      currDrones.filter(
        eachIdentification => eachIdentification.uid !== identificationUid
      )
    );
  };

  const deleteIdentificationRequest = async identificationUID => {
    const result = await authDelRequestWithParam(
      'identifications',
      identificationUID
    );
    if (result.status === 204) {
      dispatch(
        addAlert({
          title: language.alerts.addDataSuccess.title_,
          desc: language.alerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
      handleDeletion(identificationUID);
    } else
      dispatch(
        addAlert({
          title: language.alerts[result.data.code].title_,
          desc: language.alerts[result.data.code].desc_,
          type: 'error',
        })
      );
  };

  const handleUpdateZoneDrones = data => {
    setZoneDrones(currZoneDrones => [...currZoneDrones, data]);
  };

  const handleApiAddIdentification = async requestData => {
    const result = await authPostRequest('identifications', requestData);
    if (result.status === 201) {
      dispatch(
        addAlert({
          title: language.alerts.addDataSuccess.title_,
          desc: language.alerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
      handleUpdateZoneDrones(result.data);
    } else {
      dispatch(
        addAlert({
          title: language.alerts[result.data.code].title_,
          desc: language.alerts[result.data.code].desc_,
          type: 'error',
        })
      );
    }
  };

  const successAddDrone = data => {
    if (data.isPresent) {
      setDroneThatIsPresentInDb(data.data);
    } else {
      const identificationRequestObject = {
        zone: zoneUid,
        drone: data.data.uid,
        approval: 'friend',
      };
      handleApiAddIdentification(identificationRequestObject, false, data.data);
    }
  };

  const handleApiRequestAddDrone = async id => {
    const result = await authPostRequest('drones', { id });
    if (result.status === 200) {
      successAddDrone(result.data);
    } else
      dispatch(
        addAlert({
          title: language.alerts[result.data.code].title_,
          desc: language.alerts[result.data.code].desc_,
          type: 'error',
        })
      );
  };

  const handleConfirmModal = () => {
    const identificationRequestObject = {
      zone: zoneUid,
      drone: droneThatIsPresentInDb.uid,
      approval: 'friend',
    };
    handleApiAddIdentification(identificationRequestObject, true);
    setDroneThatIsPresentInDb(null);
  };

  const handleCancelModal = () => {
    setDroneThatIsPresentInDb(null);
  };

  return (
    <Grid
      container
      spacing={2}
      className={`${formClasses.Form}__overflow-component--no-min-height ${formClasses.Form}__overflow-component ${formClasses.Form}--padding-left-right`}
      style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
    >
      <Container>
        <Typography
          variant="h3"
          className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
        >
          {language.zonesDetails.addForm.addApprovedDronesForm.header_}
        </Typography>
      </Container>
      <Container>
        <Grid component="form" noValidate>
          <Grid
            container
            spacing={2}
            className={`${formClasses.Form}--flex`}
            style={{ alignItems: 'flex-end' }}
          >
            <Grid item style={{ flex: 1 }}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: newDroneError,
                })}
                htmlFor="newDrone"
              >
                {language.zonesDetails.addForm.addApprovedDronesForm.id_}
              </label>
              <TextField
                autoComplete="newDrone"
                name="newDrone"
                error={newDroneError}
                required
                fullWidth
                id="newDrone"
                onChange={handleChange}
                value={newDroneId}
                size="small"
                variant="outlined"
                helperText={
                  newDroneError
                    ? language.zonesDetails.addForm.addApprovedDronesForm.error
                    : ''
                }
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
              />
            </Grid>
            <Grid item>
              <Button
                type="button"
                onClick={() => addDrone()}
                startIcon={<Icons.Actions.Add2 />}
                className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
              >
                {language.zonesDetails.addForm.addApprovedDronesForm.addButton_}
              </Button>
            </Grid>
            {addRender && (
              <Grid item>
                <Button
                  type="button"
                  className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
                  startIcon={
                    zoneDrones.length ? (
                      <Icons.Actions.Save2 />
                    ) : (
                      <Icons.Actions.Skip />
                    )
                  }
                  onClick={
                    () => setActiveStep(currStep => currStep + 1)
                    // eslint-disable-next-line react/jsx-curly-newline
                  }
                >
                  {language.zonesDetails.addForm.addApprovedDronesForm.forward_}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Container>
      <Container>
        {zoneDrones.length ? (
          <CustomizedTable
            headers={[
              language.zonesDetails.identifications.id_,
              language.zonesDetails.identifications.remove_,
            ]}
            data={zoneDrones.map(identification => ({
              id: identification.drones.id,
              remove: (
                <Icons.Actions.Close
                  onClick={
                    () => deleteIdentificationRequest(identification.uid)
                    // eslint-disable-next-line react/jsx-curly-newline
                  }
                />
              ),
            }))}
          />
        ) : (
          <Typography
            className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
            variant="h4"
          >
            {
              language.zonesDetails.addForm.addApprovedDronesForm
                .noIdentificationDrones_
            }
          </Typography>
        )}
      </Container>
      <Container>
        {!!droneThatIsPresentInDb && (
          <>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
                >
                  {
                    language.zonesDetails.addForm.addApprovedDronesForm
                      .presentDroneHeader_
                  }
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
                  variant="h4"
                >
                  {
                    language.zonesDetails.addForm.addApprovedDronesForm
                      .presentDroneHeaderSubtitle_
                  }
                  :
                </Typography>
              </Grid>
              <Grid item container spacing={2}>
                <Grid
                  item
                  align="right"
                  xs={6}
                  className={`${formClasses.Form}__text-field--focused`}
                >
                  {`${language.zonesDetails.addForm.addApprovedDronesForm.id_}: `}
                </Grid>
                <Grid
                  item
                  xs={6}
                  className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__subtitle`}
                >
                  {droneThatIsPresentInDb.id}
                </Grid>
              </Grid>
              <Grid item container spacing={2}>
                <Grid
                  item
                  align="right"
                  xs={6}
                  className={`${formClasses.Form}__text-field--focused`}
                >
                  {`${language.zonesDetails.addForm.addApprovedDronesForm.createdAt_}: `}
                </Grid>
                <Grid
                  item
                  xs={6}
                  className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__subtitle`}
                >
                  {parseDate(droneThatIsPresentInDb?.created, timezone)}
                </Grid>
              </Grid>
              <Grid item container spacing={2}>
                <Grid
                  item
                  xs={6}
                  align="right"
                  className={`${formClasses.Form}__text-field--focused`}
                >
                  {`${language.zonesDetails.addForm.addApprovedDronesForm.serialNumber_}: `}
                </Grid>
                <Grid
                  item
                  xs={6}
                  className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__subtitle`}
                >
                  {droneThatIsPresentInDb?.serial_nr}
                </Grid>
              </Grid>
            </Grid>
            <div
              className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--width`}
            >
              <Button
                onClick={() => handleCancelModal()}
                className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
                startIcon={<Icons.Actions.Close />}
              >
                {language.zonesDetails.addForm.addApprovedDronesForm.cancel_}
              </Button>
              <Button
                onClick={() => handleConfirmModal()}
                startIcon={<Icons.Actions.Accept />}
                className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
              >
                {language.zonesDetails.addForm.addApprovedDronesForm.confirm_}
              </Button>
            </div>
          </>
        )}
      </Container>
    </Grid>
  );
};

AddApprovedDronesForm.propTypes = {
  language: PropTypes.object.isRequired,
  setActiveStep: PropTypes.func,
  timezone: PropTypes.string.isRequired,
  zoneUid: PropTypes.string.isRequired,
  addRender: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
  timezone: state.timezone,
});

export default connect(mapStateToProps)(AddApprovedDronesForm);
